// Pure, DOM-free, unit-testable helpers for the city SEO content block.

const KEY = 'containers.city.seo';

// Optional sub-sections in render order; each shows only when its i18n keys exist
// for the locale, so untranslated locales degrade instead of leaking a raw {key}.
// The H1 is not listed - it always renders via its defaultMessage.
const OPTIONAL_SECTIONS = [
  { id: 'intro', keys: [`${KEY}.location.sub-title`] },
  { id: 'explainer', keys: [`${KEY}.accordian-section.headline`, `${KEY}.accordian-section.content`] },
  { id: 'about', keys: [`${KEY}.about.content`] },
];

// Ids of the optional sections whose i18n keys are all present.
export const visibleSections = (messages = {}) =>
  OPTIONAL_SECTIONS.filter((section) => section.keys.every((key) => messages[key])).map((s) => s.id);

// Interpolation vars for the city SEO strings. Service term and brand name come
// from i18n so they stay localized per domain; word order lives in the strings.
export const seoVars = (intl, city) => ({
  city,
  serviceTerm: intl.formatMessage({ id: `${KEY}.serviceTerm`, defaultMessage: 'household help' }),
  domainName: intl.formatMessage({ id: `${KEY}.domainName`, defaultMessage: 'our website' }),
});

// City lifecycle state from the SSR worker list: only a resolved-but-empty []
// means 0-ad; anything else (including undefined) is the list state, so the 0-ad
// layout never flashes over a city that has ads.
export const resolveCityState = (ssrWorkers) =>
  Array.isArray(ssrWorkers) && ssrWorkers.length === 0 ? 'zero' : 'list';

export { OPTIONAL_SECTIONS };
